import * as React from 'react';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import { SelectButton } from 'primereact/selectbutton';

interface IProps {
    onLangChange: any
}

interface IState {
    currentLang: string
}

class Language extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            currentLang: 'bg',
        }
    }

    componentDidMount() {
        let lang = localStorage.getItem('lang');

        if (!lang) {
            localStorage.setItem('lang', 'bg');
        } else {
            this.props.onLangChange(lang);
        }

        this.setState({
            currentLang: localStorage.getItem('lang') + ''
        })
    }

    handleChangeLang = (lang) => {
        if (lang) {
            localStorage.setItem('lang', lang);
            this.props.onLangChange(lang);
            this.setState({
                currentLang: lang
            })
        }
        //window.location.reload();
    }

    public render() {
        const { currentLang } = this.state;
        const langs = [
            { label: 'BG', value: 'bg' },
            { label: 'EN', value: 'en' }
        ];

        return (
            <SelectButton value={currentLang} options={langs} onChange={(e) => this.handleChangeLang(e.value)} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLangChange: (lang) => dispatch({ type: actionTypes.LANG_CHANGE, lang: lang })
    }
}

export default connect(null, mapDispatchToProps)(Language);